module.exports = __webpack_public_path__ + "img/Windows_2_MockedUp.44e0a3c6.jpg";